import React, { Component } from "react";
import { connect } from "react-redux";
import TextFields from '../UI/TextField-f';
import Dialog from '../UI/Dialog';
import { Formik, Form } from 'formik';

import { getVAT, editVAT } from "../../store/actions";
import * as yup from "yup";


class Settings extends Component {

    state = {
        isDialogOpen: false,
    };

    componentDidMount() {
        this.props.getVAT();
    }

    changeVat =(e) => {
        e.preventDefault();
        this.props.editVAT(this.props.vat[0].id, this.state.data);
        this.setState({
            isDialogOpen: false,
            data: null
        })
    }

    render() {
        if(!this.props.vat){
            return null;
        }
        return (
            <React.Fragment>
                <div className="page-title">
                    <div className="container">
                        <div className="row flex-center-y justify-center">
                            <h1 className="color-grey">Settings</h1>
                        </div>
                    </div>
                </div>
                <div className="container box inner-padding py-15">
                    <div className="box-body">
                        <div className="row">
                            <div className="col-xs-6">
                                <Formik
                                    validationSchema={yup.object().shape({
                                        vat: yup.string().required('This field is mandatory.')
                                    })}
                                    initialValues={{ vat: this.props.vat[0].value || '' }}
                                    onSubmit={(submittedValues, actions) => {
                                        const data = {value: submittedValues.vat};
                                        this.setState({
                                            isDialogOpen: true,
                                            data
                                        })

                                    }} >
                                    {props => {
                                        const {
                                            values,
                                            touched,
                                            errors,
                                            dirty,
                                            isSubmitting,
                                            handleChange,
                                            handleBlur,
                                            handleSubmit,
                                            handleReset,
                                        } = props;
                                        return (
                                            <Form>
                                                <div className="row flex align-end">
                                                    <div className="col-xs-7">
                                                        <TextFields name="vat"
                                                                    value={ values.vat }
                                                                    onChange={ handleChange }
                                                                    onBlur={ handleBlur }
                                                                    id='vat'
                                                                    floatingLabelText="VAT% (value added tax)"
                                                                    type="text"/>
                                                    </div>
                                                    <button type='submit' className="btn filled primary min-120 ml-45 mb-10">Save</button>
                                                </div>

                                            </Form>
                                        );
                                    }}
                                </Formik>
                            </div>
                        </div>
                    </div>
                </div>

                <Dialog open={this.state.isDialogOpen} handleClose={ () => this.setState({ isDialogOpen: false }) }>
                    <form onSubmit={this.changeVat}>
                        <div className="popup-title">
                            <h2><i className="fa fa-exclamation-triangle mr-15 color-red" aria-hidden="true"></i>Are you
                                sure you want to make changes?</h2>
                        </div>

                        <div className="popup-meta flex justify-end">
                            <button
                                className="no-style w-600 pointer mx-20"
                                onClick={() =>
                                    this.setState({
                                        isDialogOpen: false,
                                        data: null
                                    })
                                }
                            >
                                No
                            </button>
                            <button type="submit" className="btn filled primary min-120">
                                Yes
                            </button>
                        </div>
                    </form>
                    <button className="no-style close-btn" onClick={ () => this.setState({ isDialogOpen: false }) }>×</button>
                </Dialog>

            </React.Fragment>

        );
    }
}

const mapStateToProps = state => {
    return {
        vat: state.settings.vat
    };
};

export default connect( mapStateToProps, { getVAT, editVAT })(Settings);



// WEBPACK FOOTER //
// ./src/components/Settings/Settings.js